// us,ca,eu,uk,de,fr,it,es 时间一样
const TimeLineProd: any = {
    jp: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        detail: '2023/04/26 10:00:00 GMT+8',
        shopify: '2023/05/17 23:00:00 GMT+8',
    },
    // kr 只有预热， 进入detail后直接redirect404
    kr: {
        teaser: '2024/03/10 11:00:00 GMT+8',
        // detail: '2023/06/30 23:00:00 GMT+8',
        // detail: '2024/06/30 23:00:00 GMT+8',
    },
    // 2023/07/03 预热 + 详情
    au: {
        teaser: '2023/07/03 10:00:00 GMT+8',
        detail: '2023/07/18 10:00:00 GMT+8',
    },
};

const TimeLineTest = {
    teaser: '2023/04/19 16:00:00 GMT+8',
    detail: '2023/07/05 10:39:00 GMT+8',
    shopify: '2023/07/26 16:30:00 GMT+8',
};

export const getGlacierWave2Timeline = (locale: string, flag?: boolean) => {
    const prodTime = TimeLineProd[locale] || TimeLineProd['jp'];
    return flag ? TimeLineTest : prodTime;
};
